import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CommonLibService {

  async generateCodeChallenge() {
    const codeVerifier = this.generateRandomString(64);
    sessionStorage.setItem('codeVerifier', codeVerifier);

    const codeChallenge = await this.pkceChallengeFromVerifier(codeVerifier);
    sessionStorage.setItem('codeChallenge', codeChallenge);

    return codeChallenge;
  }

  generateRandomString(length: number): string {
    const charset =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    let result = '';
    const values = new Uint8Array(length);
    window.crypto.getRandomValues(values);
    for (let i = 0; i < values.length; i++) {
      result += charset.charAt(values[i] % charset.length);
    }
    return result;
  }

  async pkceChallengeFromVerifier(verifier: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    const digest = await window.crypto.subtle.digest('SHA-256', data);

    return this.base64UrlEncode(new Uint8Array(digest));
  }

  base64UrlEncode(buffer: Uint8Array): string {
    let binary = '';
    const len = buffer.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(buffer[i]);
    }
    return btoa(binary)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  }

  onSelectedDateRange(selectedDateRange: string) {
    const today = new Date();
    const startOfDay = (date: Date) => new Date(date.setHours(0, 0, 0, 0));
    const endOfDay = (date: Date) => new Date(date.setHours(23, 59, 59, 999));

    let startDate: Date | null = null;
    let endDate: Date | null = null;

    switch (selectedDateRange) {
      case 'today':
        startDate = startOfDay(new Date(today));
        endDate = new Date();
        break;

      case 'yesterday': {
        const y = new Date(today);
        y.setDate(y.getDate() - 1);
        startDate = startOfDay(new Date(y));
        endDate = endOfDay(new Date(y));
        break;
      }

      case 'last7Days': {
        const s = new Date(today);
        s.setDate(s.getDate() - 6); // include today
        startDate = startOfDay(s);
        endDate = endOfDay(today);
        break;
      }

      case 'last30Days': {
        const s = new Date(today);
        s.setDate(s.getDate() - 29); // include today
        startDate = startOfDay(s);
        endDate = endOfDay(today);
        break;
      }

      case 'lastMonth': {
        const firstDayLastMonth = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1
        );
        const lastDayLastMonth = new Date(
          today.getFullYear(),
          today.getMonth(),
          0
        );
        startDate = startOfDay(firstDayLastMonth);
        endDate = endOfDay(lastDayLastMonth);
        break;
      }

      default:
        startDate = null;
        endDate = null;
        break;
    }

    return { startDate, endDate };
  }
}
